import React, { useEffect } from 'react';
import Label from 'components/_utility/Label';
import { getImageBaseUrl } from 'src/helpers/request';
import { formatFittingTime } from 'helpers/utilities';
import usePrice from 'src/hooks/usePrice';
import Wrench from 'src/assets/icons/wrench.svg';
import {
  Wrap,
  CardsWrap,
  ButtonWrap,
  Card,
  ImageWrap,
  ImageOuter,
  Image,
  Name,
  Price,
  FittingTime,
  Button,
  DetailsWrap,
  PriceTimeWrap,
} from './PackChoiceGroup.styled';

import 'objectFitPolyfill';
import cloudinary from 'helpers/cloudinary';

const AccessoryChoiceItem = ({ id, onChoose, selected, pack, noChoice }) => {
  const formatPrice = usePrice();
  const packAccessoryTotal = 0;

  useEffect(() => {
    window.objectFitPolyfill();
  }, []);

  return (
    <Wrap>
      <CardsWrap>
        <Card>
          {pack.thumbnail ? (
            <ImageWrap>
              <ImageOuter>
                <Image src={cloudinary(pack.thumbnail.src, 'c_thumb,w_180')} alt={pack.thumbnail.alt} data-object-fit />
              </ImageOuter>
            </ImageWrap>
          ) : null}
          <DetailsWrap>
            <Name>{pack.name}</Name>
            <PriceTimeWrap>
              <Price>{formatPrice(pack.isLocked ? pack.price : packAccessoryTotal)}</Price>
              <FittingTime>
                <Wrench /> {formatFittingTime(pack.fittingTime)}
              </FittingTime>
            </PriceTimeWrap>
          </DetailsWrap>
        </Card>
      </CardsWrap>
      {!noChoice ? (
        <ButtonWrap>
          <Button onClick={() => onChoose(selected ? null : id)} active={selected}>
            {selected ? <Label name="selectedLabel" /> : <Label name="selectLabel" />}
          </Button>
        </ButtonWrap>
      ) : null}
    </Wrap>
  );
};

export default AccessoryChoiceItem;
